export default "__VITE_ASSET__sIMbiW7s__"